import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";

const when = (iso) => (iso ? new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" }) : "");

/** KB landing strip for reviewers: everything waiting on *your* decision. */
export const KbReviewInbox = () => {
  const navigate = useNavigate();
  const [mine, setMine] = useState([]);
  useEffect(() => {
    api.get("/kb/review/queue").then((r) => setMine(r.data.mine || [])).catch(() => setMine([]));
  }, []);
  if (!mine.length) return null;
  return (
    <section className="mt-6 rounded-xl border border-amber-200 bg-amber-50/70 p-4 dark:border-amber-900 dark:bg-amber-950/20"
      data-testid="kb-review-inbox">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-900 dark:text-amber-200">
        <ShieldCheck className="h-4 w-4" />
        <span data-testid="kb-review-inbox-count">
          {mine.length} {mine.length === 1 ? "item is" : "items are"} waiting for your review
        </span>
      </div>
      <ul className="mt-2 grid gap-1.5 sm:grid-cols-2">
        {mine.slice(0, 8).map((r) => (
          <li key={r.article_id}>
            <button type="button" data-testid={`kb-review-inbox-${r.slug}`}
              onClick={() => navigate(`/kb/a/${r.slug}/edit`)}
              className="flex w-full items-baseline justify-between gap-3 rounded-md bg-white/80 px-3 py-1.5 text-left text-xs shadow-sm transition-colors hover:bg-white dark:bg-slate-900/60 dark:hover:bg-slate-900">
              <span className="min-w-0 truncate font-medium text-slate-800 dark:text-slate-100">
                {r.name}
                {r.is_snippet && <span className="ml-1.5 rounded bg-indigo-50 px-1 text-[10px] font-semibold text-indigo-600">Snippet</span>}
                {r.live && <span className="ml-1.5 rounded bg-emerald-50 px-1 text-[10px] font-semibold text-emerald-700">Update to live article</span>}
              </span>
              <span className="shrink-0 text-slate-500 dark:text-slate-400">
                {r.submitted_by || r.review_requested_by}{r.review_requested_at ? ` · ${when(r.review_requested_at)}` : ""}
              </span>
            </button>
          </li>
        ))}
      </ul>
      {mine.length > 8 && (
        <p className="mt-2 text-[11px] text-amber-800 dark:text-amber-300">
          +{mine.length - 8} more — open the Article planner's In Review column to see them all.
        </p>
      )}
    </section>
  );
};
